import React from 'react';
import { Field, Modal } from '../../components/ui';

// Add/Edit reminder — phone / APK: full screen, date and time side by side,
// Active / Paused as a big segmented switch, Save fills the footer.
// Logic: useReminders.
export default function ReminderFormMobile({ vm }) {
  const { editing, form, setF, closeModal, saveReminder } = vm;
  const active = String(form.Active) === '1';
  return (
    <Modal
      fullScreen
      title={editing ? 'Edit Reminder' : 'Add Reminder'}
      onClose={closeModal}
      footer={<>
        <button className="btn light" onClick={closeModal}>Cancel</button>
        <button className="btn primary pp-grow" onClick={saveReminder}>Save</button>
      </>}
    >
      <Field label="Title" value={form.Title} placeholder="Invitation Calls" onChange={v => setF('Title', v)} />
      <div className="pp-row" style={{ gridTemplateColumns: '1fr 1fr' }}>
        <Field label="From date" type="date" value={form.StartDate} required onChange={v => setF('StartDate', v)} />
        <Field label="Reminder time" type="time" value={form.ReminderTime} required onChange={v => setF('ReminderTime', v)} />
      </div>
      <div className="pp-seg-field">Status
        <div className="pp-seg">
          <button type="button" style={{ padding: 11 }} className={active ? 'on' : ''} onClick={() => setF('Active', 1)}>Active</button>
          <button type="button" style={{ padding: 11 }} className={!active ? 'on' : ''} onClick={() => setF('Active', 0)}>Paused</button>
        </div>
      </div>
      <Field label="Notes" type="textarea" value={form.Notes} onChange={v => setF('Notes', v)} />
    </Modal>
  );
}
